namespace Gordic.Adm.WebControls.AdmSpisovna {

    export function openSeznamAdmFunkcniMistoSpisovna(data: any) {
        $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmFunkcniMistoSpisovna", { ixs_spi: data.ixs_spi }])
    }
}